import { isExist } from './coreUtil'

export const isNumber = (value: any): boolean => {
    return isExist(value) ? !isNaN(value) && typeof value === 'number' : false
}
